import React from "react"

export default function Twitter(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 455.7 455.7"
      {...props}
    >
      <path fill="#50abf1" d="M0 0h455.7v455.7H0z" />
      <path
        fill="#fff"
        d="M60.4 337.8A196.2 196.2 0 00361.3 164c3.9-3 28.1-22.5 34-35 0 0-19.6 8.2-38.9 10.1h-.1.1c1.8-1.2 26.6-18 30-38.2 0 0-14 7.4-33.5 14l-10 3a68.8 68.8 0 00-117.3 62.6c-5.4-.2-86.3-4.7-141.3-71.4 0 0-33 45 19.6 91.1 0 0-16-.6-29.8-8.8 0 0-5 54.4 54.4 68.3 0 0-11.7 4.4-30.3 1.3 0 0 10.4 44 63.2 48 0 0-41.7 37.8-101 29z"
      />
    </svg>
  )
}
